import { getApiClient, getRequestHeaders } from './zodios-client';
import type { 
  Link, 
  CreateLinkRequest, 
  AdminCreateLinkRequest,
  UpdateLinkRequest, 
  PaginationParams,
  LinkListResponse 
} from '@/types';

export const linksService = {
  async listLinks(params: PaginationParams = {}): Promise<LinkListResponse> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminListLinks({ queries: { query: params }, headers });
  },

  async getTopLinks(limit: number = 10): Promise<LinkListResponse> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminListLinks({
      queries: { query: { limit, clickOrder: 'desc' } },
      headers
    });
  },

  async createLink(data: AdminCreateLinkRequest): Promise<Link> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminCreateLink(data, { headers });
  },

  async getLink(shortCode: string): Promise<Link> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminGetLink({ params: { shortCode }, headers });
  },

  async updateLink(shortCode: string, data: UpdateLinkRequest & { tenantId?: string }): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    
    console.log('UpdateLink Debug:', {
      shortCode,
      headers,
      hasAuth: !!headers.Authorization,
      data
    });
    
    return client.adminUpdateLink(data, { params: { shortCode }, headers });
  },

  async deleteLink(shortCode: string): Promise<{ message: string }> {
    const client = getApiClient();
    const headers = getRequestHeaders();
    return client.adminDeleteLink(undefined, { params: { shortCode }, headers });
  },

  // Helper method to get full short URL
  getFullShortUrl(shortCode: string): string {
    const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';
    return `${baseUrl}/${shortCode}`;
  },

  // Helper method to copy to clipboard
  async copyToClipboard(text: string): Promise<boolean> {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      console.error('Failed to copy to clipboard:', error);
      return false;
    }
  }
};
